import React from 'react';
import betImg from '../assets/images/partners/bet.png';
import betSafeImg from '../assets/images/partners/betsafe.png';
import myStakeImg from '../assets/images/partners/mystake.png';
import roobetImg from '../assets/images/partners/roobet.png';
import stakeImg from '../assets/images/partners/stake.png';
import xbetImg from '../assets/images/partners/xbet.png';
import tikTokImg from '../assets/images/social_media/tiktok.png';
import MetaImg from '../assets/images/social_media/meta.png';
import googleImg from '../assets/images/social_media/google.png';
import xImg from '../assets/images/social_media/x.png';
import snapchatImg from '../assets/images/social_media/snapchat.png';
import linkedinImg from '../assets/images/social_media/linkedin.png';
import tikTokDeskImg from '../assets/images/social_media/tiktokDesk.png';
import MetaDeskImg from '../assets/images/social_media/metaDesk.png';
import googleDeskImg from '../assets/images/social_media/googleDesk.png';
import xDeskImg from '../assets/images/social_media/xDesk.png';
import snapchatDeskImg from '../assets/images/social_media/snapchatDesk.png';
import linkedinDeskImg from '../assets/images/social_media/linkedinDesk.png';
import apacImg from '../assets/images/awards/apac.png';
import microsoftImg from '../assets/images/awards/microsoft.png';
import deloitteImg from '../assets/images/awards/deloitte.png';
import bestImg from '../assets/images/awards/best.png';
import apacDeskImg from '../assets/images/awards/apac_desk.png';
import microsoftDeskImg from '../assets/images/awards/microsoft_desk.png';
import deloitteDeskImg from '../assets/images/awards/deloitte_desk.png';
import bestDeskImg from '../assets/images/awards/best_desk.png';

export const awardsData = [
  {
    img: apacImg,
    imgDesk: apacDeskImg,
    alt: 'Apac Search Awards Winner 2023',
  },
  {
    img: microsoftImg,
    imgDesk: microsoftDeskImg,
    alt: 'Global Partner Awards Winner 2023',
  },
  {
    img: deloitteImg,
    imgDesk: deloitteDeskImg,
    alt: 'Deloitte Tech Fast  Winner',
  },

  {
    img: bestImg,
    imgDesk: bestDeskImg,
    alt: 'Spring Awards 2023',
  },
];

export const socialMediaData = [
  {
    img: tikTokImg,
    imgDesk: tikTokDeskImg,
    alt: 'Tik Tok',
  },
  {
    img: MetaImg,
    imgDesk: MetaDeskImg,
    alt: 'Meta',
  },
  {
    img: googleImg,
    imgDesk: googleDeskImg,
    alt: 'Google',
  },
  {
    img: xImg,
    imgDesk: xDeskImg,
    alt: 'X',
  },
  {
    img: snapchatImg,
    imgDesk: snapchatDeskImg,
    alt: 'Snapchat',
  },
  {
    img: linkedinImg,
    imgDesk: linkedinDeskImg,
    alt: 'LinkedIn',
  },
];

export const projectsData = ['iGaming', 'Crypto', 'Investment', 'projects'];

export const advantagesListData = [
  {
    amount: (
      <>
        <span>$9</span>,5m+
      </>
    ),
    title: 'Ads spend',
    description:
      'Total amount of money raised as a result of working with Walk Studio',
  },
  {
    amount: '32+',
    title: 'Awards & Licenses',
    description: 'We have received various awards with prayers and efforts',
  },
  {
    amount: '400+',
    title: 'Our Client',
    description:
      'Total of all clients around the world who have collaborated with us',
  },
  {
    amount: (
      <>
        425<span>+</span>
      </>
    ),
    title: 'Project Complete',
    description:
      'Various kinds of big projects that you have completed on time',
  },
];

export const servicesListData = [
  {
    icon: '#icon-stratagy',
    title: 'Korben',
    span: 'STRATEGY',
  },
  {
    icon: '#icon-hand-shake',
    title: 'Dallas',
    span: 'DESIGN',
  },
  {
    icon: '#icon-client',
    title: 'K&D',
    span: 'Media Buying',
    text: 'Full service for teams and personal buyers',
  },
  {
    icon: '#icon-client',
    title: 'AGENCY AD ACCOUNTS',
  },
];

export const communityData = [
  'TIPS',
  'CASES',
  'INSIGHTS',
  'VIDEOS',
  'SERVICES',
  'ACTUAL FEED',
];

export const partnersData = [
  {
    iconName: '#icon-marketsavy',
    width: '178',
    height: '26.88',
  },
  {
    iconName: '#icon-epicdev',
    width: '178',
    height: '37.22',
  },
  {
    iconName: '#icon-bestbank',
    width: '178',
    height: '42.65',
  },
  {
    iconName: '#icon-starsup',
    width: '178',
    height: '42.13',
  },
  {
    iconName: '#icon-globalchart',
    width: '178',
    height: '28.54',
  },
  {
    iconName: '#icon-nextflows',
    width: '178',
    height: '28.74',
  },
];

export const partnersCasinoData = [
  roobetImg,
  xbetImg,
  stakeImg,
  betImg,
  betSafeImg,
  myStakeImg,
];

export const navData = [
  {
    name: 'Services',
    hash: '#services',
  },
  {
    name: 'Work',
    hash: '#work',
  },
  {
    name: 'Partners',
    hash: '#partners',
  },
];
